import React, {Component, resetGlobal} from 'reactn';
import {Redirect} from 'react-router-dom';
import {withApollo} from 'react-apollo';
import axios from "axios";
// import EventLogger from "../../../components/EventLogger";

class Logout extends Component {
    componentWillMount() {
        try {
            axios.delete('/oauth/spring-security-oauth-server/token/current', {headers: {'Authorization': 'Bearer ' + localStorage.token}});
        } finally {
            // EventLogger(this.global.user.username, "LOGOUT");
            document.cookie = "token=false;expires=" + (new Date()).toUTCString() + ";path=/";
            delete localStorage.token;
            resetGlobal();
            this.props.client.resetStore();
            delete localStorage.org;
        }
    }

    render() {
        return (<Redirect to={{
            pathname: '/login',
        }}/>);
    }
}

export default withApollo(Logout);
